module.exports = __webpack_public_path__ + "static/fair-harbor-hero.a6f7b4df.jpg";